import { UnistackZoneListRsp } from 'cms-typescript-sdk/unistack/models/unistack-zone-list-rsp';
import { ZoneServiceService } from 'cms-typescript-sdk/unistack/services';
import { Sort } from '@angular/material/sort';
import { SortableDataProvider } from '@shared/models/data-provider.model';
import { Observable } from 'rxjs';
import ZoneListParams = ZoneServiceService.ZoneListParams;

export class ZonesSortParams implements ZoneListParams {
  metaSort?: string;
  metaOrder?: string;
}

export class ZonesDataProvider extends SortableDataProvider<UnistackZoneListRsp, ZonesSortParams> {

  protected sortParams = new ZonesSortParams();

  constructor(private zoneService: ZoneServiceService) {
    super();
  }

  public loadData(): Observable<UnistackZoneListRsp> {
    const params = {
      ...{
        metaLimit: String(this.page.pageSize),
        metaOffset: String(this.page.currentIndex)
      },
      ...this.sortParams
    };

    return this.zoneService.ZoneList(params);
  }


  sort(params: Sort) {
    if (params.direction) {
      this.sortParams.metaSort = params.active;
      this.sortParams.metaOrder = params.direction;
    } else {
      this.sortParams.metaSort = undefined;
      this.sortParams.metaOrder = undefined;
    }

    this.reload();
  }
}
